import React from 'react'

import {MenuComponentProps} from "../const"
import NavigationMenuSection from "../../menu-items/section/section"
import NavigationMenuItemUrl from "../../menu-items/menu-item-url"
import {Feature} from "../../../../core/gd/access-control/feature-access/const";
import NavigationMenu_ProjectsTags from "../tags/tags";

export default function NavigationMenu_ToolsContent(props: MenuComponentProps) {

    const isManager = gd.user.acl.isManager
    const rootTags = gd.session.projects.rootTags

    const showForms = isManager /*&& (gd.modules.requests.enabled || gd.modules.publicForms.enabled)*/
    const showTags = rootTags?.length > 0

    return (
        <>
            {isManager &&
                <NavigationMenuSection name         = "Automations"
                                       systemName   = "tools-automations"
                                       collapsible  = {false}>
                    <NavigationMenuItemUrl name                     = "Automations"
                                           icon                     = "i5-automation"
                                           url                      = "o/automations"
                                           upgradeRequiredFeature   = {Feature.AUTOMATIONS}
                                           navigationSection        = {gd.spaces.tools.navigation}/>

                    <NavigationMenuItemUrl name                     = "Actions"
                                           icon                     = "ii5-lightning"
                                           url                      = "o/actions"
                                           upgradeRequiredFeature   = {Feature.ACTIONS}
                                           navigationSection        = {gd.spaces.tools.navigation}/>

                    <NavigationMenuItemUrl
                        name                = "Recurring Items"
                        icon                = "i5-recurrence"
                        url                 = "o/recurrences"
                        navigationSection   = {gd.spaces.tools.navigation}
                    />

                    <NavigationMenuItemUrl name                     = "Validations"
                                           icon                     = "i5-emergency"
                                           url                      = "o/validations"
                                           upgradeRequiredFeature   = {Feature.VALIDATIONS}
                                           navigationSection        = {gd.spaces.tools.navigation} />
                </NavigationMenuSection>
            }

            {showForms &&
                <NavigationMenuSection name         = "Forms"
                                       systemName   = "tools-forms"
                                       collapsible  = {false}>
                    <NavigationMenuItemUrl className            = "item"
                                           name                 = "Forms"
                                           icon                 = "i5-form"
                                           url                  = "o/forms"
                                           navigationSection    = {gd.spaces.tools.navigation}/>

                    <NavigationMenuItemUrl className            = "item"
                                           name                 = "Requests"
                                           icon                 = "i5-request"
                                           url                  = "o/requests"
                                           navigationSection    = {gd.spaces.tools.navigation}/>
                </NavigationMenuSection>
            }

            <NavigationMenuSection name         = "Import/Export"
                                   systemName   = "tools-import-export"
                                   collapsible  = {false}>
                <NavigationMenuItemUrl className            = "item"
                                       name                 = "Import"
                                       icon                 = "i5-import-from"
                                       url                  = "o/import"
                                       navigationSection    = {gd.spaces.tools.navigation}/>
                <NavigationMenuItemUrl className            = "item"
                                       name                 = "Export"
                                       icon                 = "i5-export-to"
                                       url                  = "o/export"
                                       navigationSection    = {gd.spaces.tools.navigation}/>
            </NavigationMenuSection>

            {showTags &&
                <NavigationMenu_ProjectsTags
                    showAdd = {true}
                    tags    = {rootTags}
                />
            }

            <NavigationMenuSection name         = "Misc"
                                   systemName   = "companyTools"
                                   collapsible  = {false}>
                <NavigationMenuItemUrl name                 = "Big Screens"
                                       icon                 = "i5-tv"
                                       url                  = {'o/big-screen'}
                                       navigationSection    = {gd.spaces.tools.navigation}/>
            </NavigationMenuSection>


            <NavigationMenuSection name         = "Archived & Deleted"
                                   systemName   = "companyTools"
                                   collapsible  = {false}>
                {isManager &&
                    <NavigationMenuItemUrl name                 = "Deleted Users"
                                           icon                 = "i5-users"
                                           url                  = {'o/deleted-users'}
                                           navigationSection    = {gd.spaces.tools.navigation}/>
                }
                <NavigationMenuItemUrl name                 = "Archived Projects"
                                       icon                 = "i5-someday"
                                       url                  = {'o/archived-projects'}
                                       navigationSection    = {gd.spaces.tools.navigation}/>

                <NavigationMenuItemUrl name                     = "Trash"
                                       icon                     = "i5-trash-alt"
                                       url                      = {'o/trash'}
                                       upgradeRequiredFeature   = {Feature.TRASH}
                                       navigationSection        = {gd.spaces.tools.navigation} />
            </NavigationMenuSection>
        </>
    )
}
